<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-row
    v-show="currClientState"
    no-gutters
    class="fill-height">
    <v-col cols=6 class="fill-height">
      <v-sheet
          height="100vh"
          width="100vw"
          class="whitespace fill-height fill-width"
          @click="close()"
        >
      </v-sheet>
    </v-col>
    <v-col cols=6 class="sideview" height="200px">
        <v-sheet
          elevation="3"
          height="100vh"
          width="100vw"
          class="sideview fill-height fill-width"
        >
            <v-row
              class="px-6 pt-2 fill-height">
              <v-col cols=6 class="pt-2 pb-12 fill-height">
                <div class="d-flex">
                  <div class="d-inline pa-2 ml-auto">
                    <TheMiniLoader :loading="isLoading" />
                  </div>
                  <v-btn
                    icon
                    color="textColor"
                    class="ml-4"
                    @click="refreshData"
                  >
                    <v-icon>mdi-autorenew</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="textColor"
                    @click="close"
                  >
                    <v-icon>mdi-window-close</v-icon>
                  </v-btn>
                </div>
                  <span class="title grayBold--text">
                      {{ $t("client") }}
                  </span>
                  <v-list-item two-line>
                    <v-list-item-avatar
                      tile
                      size=60
                     >
                        <!-- <v-icon large color="grayBold">
                          mdi-home-city-outline
                        </v-icon> -->
                        <v-img :src="require('@/assets/img/client_icon.png')"/>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="overline pl-2 mb-1 titleGrey--text">{{ $t("name_uppercase") }}</v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1 pl-2 titleGrey--text">{{ currClient.info.firstname }} {{ currClient.info.lastname }} </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-btn
                          small
                          light
                          elevation="0"
                          class="titleGrey--text"
                          @click="editClient"
                        >
                          <v-icon color="primary" left>
                            mdi-pencil
                          </v-icon>
                          {{$t("edit_for_uppercase")}}
                        </v-btn>
                        <v-btn
                          small
                          light
                          elevation="0"
                          class="titleGrey--text"
                          @click="deleteClient"
                        >
                          <v-icon color="primary" left>
                            mdi-delete
                          </v-icon>
                          {{$t("delete_for_uppercase")}}
                        </v-btn>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                <v-tabs 
                  v-model="tab"
                  color="primary"
                  show-arrows
                  background-color="transparent"
                  class="tabs" light>
                  <v-tab >{{ $t("general") }}</v-tab>
                  <v-tab>{{ $t("installations_uppercase") }}</v-tab>
                  <v-tab>{{ $t("devices_uppercase") }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item light key=0>
                    <ClientsSideviewGeneralTab :client="currClient"/>
                  </v-tab-item>
                  <v-tab-item light key=1>
                    <ClientsSideviewInstallationsTab :client="currClient"/>
                  </v-tab-item>
                  <v-tab-item light key=2>
                    <ClientsSideviewDevicesTab :client="currClient"/>
                  </v-tab-item>
                </v-tabs-items>
                  <v-divider class="mx-4 mt-2"/>
                  <v-list-item class="pt-12">
                    <v-list-item-content>
                      <v-list-item-title class="overline textColor2--text">
                        {{ $t("created_uppercase") }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="pt-1 textColor2--text"> {{ formatDate(currClient.info.created_at) }} {{$t("by")}} {{currClient.info.created_by}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content class="ml-6">
                      <v-list-item-title class="overline textColor2--text">
                        {{ $t("updated_uppercase") }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="pt-1 textColor2--text"> {{ formatDate(currClient.info.updated_at) }} {{$t("by")}} {{currClient.info.updated_by}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
              </v-col>
            </v-row>
        </v-sheet>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, clientsModule, installationsModule } from '@/store/modules/store-accessor'
import LoadingIndicator from '@/components/TheLoadingIndicator.vue'
import ClientsSideviewGeneralTab from '@/components/sideviews/clients/ClientsSideviewGeneralTab.vue'
import ClientsSideviewInstallationsTab from '@/components/sideviews/clients/ClientsSideviewInstallationsTab.vue'
import ClientsSideviewDevicesTab from '@/components/sideviews/clients/ClientsSideviewDevicesTab.vue'
import { TimeUtil } from '@/helpers/TimeUtil'
import TheMiniLoader from '@/components/TheMiniLoader.vue'
import _ from 'lodash';

@Component({
  components: {
    LoadingIndicator,
    ClientsSideviewGeneralTab,
    ClientsSideviewDevicesTab,
    ClientsSideviewInstallationsTab,
    TheMiniLoader,
  }
})
export default class ClientsSideview extends Vue {
  @Prop()
  loading!: boolean;

  @Prop()
  payload!: any;

  tab = 0;

  isEditing!: boolean;

  async mounted() {
    installationsModule.getInstallationsByIdAction(this.payload?.clientId);
  }

  async hideSideview () {
    commonModule.hideSideview();
  }

  get currClientId () {
    return this.payload?.clientId;
  }

  get currClient () {
    return clientsModule.currentClient;
  }

  get isLoading() {
    return clientsModule.isLoadingSideView;
  }

  get currClientState() {
    return !(_.isEmpty(this.currClient))
  }

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  updated() {
    this.isEditing = false;
  }

  refreshData () {
    clientsModule.setIsLoadingSideView(true);
    clientsModule.getClientsInfo(this.currClientId)
  }
  

  async editClient() {
    await clientsModule.getClientsInfo(this.currClientId)
    commonModule.showModal({ name: 'edit-client-modal', payload: { client: this.currClient.info, contacts: this.currClient.contacts, view: "clientsSideview" }})
  }

  deleteClient() {
    commonModule.showModal({ name: 'delete-client-modal', payload: { client: this.currClient.info }} )
  }

  close () {
    clientsModule.unsetCurrentClient();
    this.hideSideview()
  }

};
</script>

<style scoped lang="scss">

.sideview {
  // height: 100%;
  // width: 100%;
  background-color:whitesmoke;
}

.tabs {
  background: $whitesmoke;
  color:transparent;
}

.title {
  margin-top: 5px;
  // font-size: 25px;
  font-size: 35;
  font-weight: 500;
  // line-height: 65px;
}

h2 {
  color: $dark-blue-grey;
}

span {
  margin-left: 10px;
  font-size: 1.5rem !important;
  font-weight: 400;
  color: $pale-purple;
}

.close-btn {
  color: $card-title-color;
}

.loading {
  margin: 5px;
  right: 1px;
}

.chip {
  font-size: 12px !important;
}

.whitespace {
  width: 100%;
  height: 100%;
  background-color:transparent;
}
</style>
